import React, { useEffect, useState } from "react";

import { RideButton, RideGrid } from "@rimac-seguros/ride-system-components";

import headerLogo from '@/assets/rebrand/header/logo-rimac.svg';

import "./styles.scss";

const Header = ({
  className,
  backGround = "bg-ride-sys-color-background-default",
}) => {

  return (
    <header
      className={`container-header ${backGround ? backGround : ""}`}
    >
      <RideGrid>
        <div
          className={`container-header_content ${className ? className : ""}`}
        >
          <div className="container-header_left">
            <div className="container-header_left-img">
              <img
                src={headerLogo}
                alt="Logo Rimac"
              />
            </div>
          </div>
        </div>
      </RideGrid>
    </header>
  );
};

export default Header;